import Button from "../../../custom/button/button";
import { ReactComponent as Add } from "../../../assets/Plus Math.svg";
import { ReactComponent as Delete } from "../../../assets/deleteIcon.svg";
import { ReactComponent as View } from "../../../assets/view.svg";
//import { ReactComponent as Print } from "../../../assets/Print.svg";
// import { ReactComponent as DownloadPdf } from "../../../assets/Export Pdf.svg";
import { ReactComponent as Cancel } from "../../../assets/cancel.svg";
import PageLayout from "../../../layouts/pageLayout/pageLayout";
import styles from "../dashboardPage.module.scss";
import { App, Modal, Spin, Table } from "antd";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useMutation, useQuery } from "@tanstack/react-query";
import api from "../../../utils/api";
import { AxiosError } from "axios";
import { ColumnsType } from "antd/es/table";
import { useAtomValue } from "jotai";
import { userAtom } from "../../../utils/store";
import QualificationForm from "./form";
import { FormikValues } from "formik";

interface QualificationResponse extends Response {
  data: Qualification[];
}

const Qualification = () => {
  const { notification } = App.useApp();
  const [showModal, setShowModal] = useState(false);
  const user = useAtomValue(userAtom);
  const navigate = useNavigate();

  const createOrUpdateQualificationMutation = useMutation({
    mutationFn: async (payload: FormData) => {
      return (await api.post(
        "/StudentInfo/StudentInfo/CreateUpdateQualification",
        payload
      )) as Response;
    },
  });
  const deleteQualificationMutation = useMutation({
    mutationFn: async (id: number) => {
      return (await api.delete(
        `/StudentInfo/StudentInfo/DeleteQualification?Id=${id}`
      )) as Response;
    },
  });
  const { data, isLoading, isError, error, refetch } = useQuery({
    queryKey: ["get-qualifications"],
    queryFn: async () => {
      return (
        await api.get(
          `/StudentInfo/StudentInfo/GetQualificationByApplicantId?Id=${user?.applicantId}`
        )
      )?.data as QualificationResponse;
    },
  });

  const column: ColumnsType<Qualification> = [
    {
      title: "S/N",
      key: "s/n",
      render: (_, _record, index) => index + 1,
    },
    {
      title: "Qualification Type",
      dataIndex: "qualificationType",
      key: "qualificationType",
    },
    {
      title: "Exam Number",
      dataIndex: "examNumber",
      key: "examNumber",
    },
    {
      title: "Certificate",
      dataIndex: "certificateiUrl",
      key: "certificate",
      //render: (text) => <a href={text}>{text}</a>,
    },
    {
      title: "Action",
      dataIndex: "TransDate",
      key: "TransDate",
      render: (_, record) => (
        <span>
          {
            <>
              <View
                onClick={() => {
                  navigate(`/view-qualification/${record?.id}`);
                }}
                style={{ marginInlineEnd: "1rem", cursor: "pointer" }}
              />

              <Delete
                style={{ cursor: "pointer" }}
                onClick={() => handleDeleteQualification(record?.id)}
              />
            </>
          }
        </span>
      ),
    },
  ];

  const qualifications = data?.data as Qualification[];

  const handleCreateorUpdateQualification = async (
    values: FormikValues,
    resetForm: () => void
  ) => {
    const payload = new FormData();
    try {
      payload.append("Id", "0");
      payload.append("ApplicantId", user?.applicantId ?? '');
      payload.append("QualificationType", values.qualificationType);
      payload.append("ExamNumber", values.examNumber);
      if (values.certificate) {
        payload.append("Certificate", values.certificate);
      }
      payload.append("CertificateiUrl", "");
      values.subjects?.forEach((subject: Subject, index: number) => {
        payload.append(`Subjects[${index}].subject`, subject.subject);
        payload.append(`Subjects[${index}].grade`, subject.grade);
        payload.append(`Subjects[${index}].activeStatus`, "true");
        payload.append(`Subjects[${index}].isDeleted`, "false");
      });
      payload.append("isDeleted", "false");
      payload.append("IsSubmmited", "true");
      await createOrUpdateQualificationMutation.mutateAsync(payload, {
        onSuccess: (data) => {
          notification.success({
            message: "Success",
            description: data?.message,
          });
          refetch();
          resetForm();
        },
      });
    } catch (error: any) {
      notification.error({
        message: "Error",
        description: error?.message || error?.response?.data?.message,
      });
    }
  };

  const handleDeleteQualification = async (id: number) => {
    try {
      await deleteQualificationMutation.mutateAsync(id, {
        onSuccess: (data) => {
          notification.success({
            message: "Success",
            description: data?.message,
          });
          refetch();
        },
      });
    } catch (error: any) {
      notification.error({
        message: "Error",
        description: error?.message || error?.response?.data?.message,
      });
    }
  };

  if (isLoading) {
    return <Spin size="large" />;
  }

  if (isError) {
    return <div>{(error as AxiosError)?.message}</div>;
  }

  return (
    <>
      <PageLayout
        heading="Qualifications"
        headerActions={
          <>
            <Button
              onClick={() => {
                setShowModal(true);
              }}
              iconBefore={<Add />}
              text="Add"
            />
            {/* <Button
              iconBefore={<DownloadPdf />}
              text="Download"
              bgColor="#CE9938"
            /> */}
          </>
        }
      >
        <Table
          columns={column}
          dataSource={qualifications}
          className={styles.row}
          rowKey={(record) => record.id}
          scroll={{ x: 400 }}
          //   pagination={{ current: currentPage, pageSize: pageSize, onChange: handlePaginationChange, position: ["bottomCenter"] }}
          pagination={false}
        />
      </PageLayout>
      <Modal
        open={showModal}
        footer=""
        onCancel={() => setShowModal(false)}
        centered
        closeIcon={<Cancel />}
        width={900}
      >
        <div className={styles.modalContent}>
          <div>
            <p>Qualification</p>
            <p>All fields marked with a (*) are required.</p>
          </div>

          <hr />

          <br />
          <QualificationForm
            qualification={undefined}
            isLoading={createOrUpdateQualificationMutation.isPending}
            onSubmit={handleCreateorUpdateQualification}
          />
        </div>
      </Modal>
    </>
  );
};

export default Qualification;
